// 透過 @ay-nestjs/share 產生
/* eslint-disable */
import { wsc } from '../wsc';
import { Observable } from 'rxjs';

export class SpinnerModel {
  static listenIsWinner(): Observable<boolean> {
    return wsc.subscribe('/ws/spinner/listenIsWinner') as any;
  }

  static listenIsFinished(): Observable<boolean> {
    return wsc.subscribe('/ws/spinner/listenIsFinished') as any;
  }

  static fetchIsWinner(): Promise<boolean> {
    return wsc.execute('/ws/spinner/fetchIsWinner') as any;
  }

  static fetchIsFinished(): Promise<boolean> {
    return wsc.execute('/ws/spinner/fetchIsFinished') as any;
  }

  static setWinner(
    winnerIdentifiers: string[],
    isBeta?: boolean,
  ): Promise<void> {
    return wsc.execute(
      '/ws/spinner/setWinner',
      winnerIdentifiers,
      isBeta,
    ) as any;
  }

  static setIsSpinExecuted(): Promise<void> {
    return wsc.execute('/ws/spinner/setIsSpinExecuted') as any;
  }

  static isSpinExecuted(): Observable<boolean> {
    return wsc.subscribe('/ws/spinner/isSpinExecuted') as any;
  }

  static fetchIsFilmstripExecuted(): Promise<boolean> {
    return wsc.execute('/ws/spinner/fetchIsFilmstripExecuted') as any;
  }
}
// 83908c4579355b33e615d1ac0e31255f436578155a129900a8ce68a8bf2a6526
